/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Deposit_PctInputs */

const en_reference_field_deposit_pct = /** @type {(inputs: Reference_Field_Deposit_PctInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposit %`)
};

/**
* | output |
* | --- |
* | "Deposit %" |
*
* @param {Reference_Field_Deposit_PctInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_deposit_pct = /** @type {((inputs?: Reference_Field_Deposit_PctInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Deposit_PctInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_deposit_pct(inputs)
});